import React from 'react';
import { NavLink } from 'react-router-dom';

export function LogsNav() {
  return (
    <nav className='subnav'>
      <NavLink exact to='/client/logs' activeClassName='active'>All Activity</NavLink>
      <NavLink exact to='/client/logs/cleanup' activeClassName='active'>Cleanup</NavLink>
    </nav>
  );
}